import { Component, EventEmitter, Input, NgZone, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  APIService,
  CreateOrderItemInput,
  Order,
  OrderItem,
  OrderStatus,
  Product,
} from "../../../services/API.service";
import { ConfirmDeleteComponent } from "../../confirm-delete/confirm-delete.component";
import { OrderService } from "../../../services/order.service";
import { API_CWSService } from "src/app/services/API_CWS.service";
import { ToastrService } from "ngx-toastr";
import { AuthService } from "src/app/services/auth.service";

@Component({
  selector: "app-order-form",
  templateUrl: "./order-form.component.html",
  styleUrls: ["./order-form.component.scss"],
})
export class OrderFormComponent implements OnInit {
  @Input() order: Order;
  @Input() customerID: string;
  @Input() viewingCurves: boolean;
  customerOrderDiscount: number;

  @Output() OrderAdded = new EventEmitter();
  @Output() OrderUpdated = new EventEmitter();
  @Output() OrderDeleted = new EventEmitter();
  @Output() CancelClicked = new EventEmitter();
  @Output() SubmitOrder = new EventEmitter<Order>();

  canDelete: boolean = true; // need to check if user has delete permissions
  orderLines: OrderItem[] = [];
  editedOrder: Order;
  viewOnly: boolean;
  addingCurve = false;
  addingCurtainTrack = false;
  addingExtraItem = false;
  loading: boolean = false;
  orderItemUpdated = false;
  orderItemAdded = false;
  itemNumber: number = 1;
  addItem: boolean = false;
  orderItem: OrderItem;
  confirmOrder: boolean;
  isAddingNewOrder = false;
  editForm: FormGroup;
  productSelected: Product;
  tags: string[] = [];

  // DDLS
  dialog: any;

  get IsTrack() {
    return this.tags.includes('track');
  }

  get IsVerticalHeadrail() {
    return this.tags.includes('vertical');
  }

  constructor(
    private ngZone: NgZone,
    private fb: FormBuilder,
    private apiService: APIService,
    private apiCWS: API_CWSService,
    private orderService: OrderService,
    private toastrService: ToastrService,
    private authService: AuthService
  ) {
    this.editForm = this.createFormGroup();
    // this.editForm.controls['isAssigned'].disable();
  }

  ngOnInit() {
    this.GetProducts();
    this.SetDDLS();
    this.resetNewItemToOriginal();
    this.onChanges();
    if (this.order) {
      this.GetOrderItems();
    }
    this.customerOrderDiscount = (this.authService.customer.orderDiscount === null || this.authService.customer.orderDiscount === undefined) ? 0 : this.authService.customer.orderDiscount;
  }
  GetProducts() {
    // this.apiService.GetProduct().then((data) => {});
  }

  // comment

  GetOrderItems() {
    this.apiService.OrderItemsByOrder(this.order.id).then((data) => {
      this.orderLines = data.items as OrderItem[];
    });
  }
  onChanges() {
    // this.editForm.controls['isTimeShifted'].valueChanges
    //   .subscribe(isTimeShifted => {
    //     if (isTimeShifted === true) {
    //       this.editForm.controls['shiftedDelay'].enable();
    //     }
    //     else {
    //       this.editForm.controls['shiftedDelay'].disable();
    //     }
    //   });
  }

  SetDDLS(): any {
    //   this.triggerService.GetTriggers().subscribe(data => { this.triggers = data})
  }

  resetNewItemToOriginal() {
    // set the temp to the orginal
    this.formSetValue();
  }

  formSetValue() {
    if (this.order !== undefined) {
      this.isAddingNewOrder = false;
      this.editForm.reset({
        id: this.order.id,
        orderNo: this.order.orderNo,
        customerReference: this.order.customerReference,
        dateOrdered: this.order.dateOrdered,
        orderTotal: this.order.orderTotal,
        orderNotes: this.order.orderNotes,
        // items: this.order.orderItems.items,
        orderStatus: this.order.orderStatus,
        customerID: this.order.customerID,
      });
    } else {
      this.isAddingNewOrder = true;
      // set defaults
      this.editForm.reset({
        id: undefined,
        orderNo: "auto-generated",
        dateOrdered: Date.now(),
        orderStatus: OrderStatus.quote,
        customerReference: "",
        orderNotes: "",
        orderTotal: 0,
        customerID: this.customerID,
      });
    }
  }

  //  Validators.pattern(Constants.numberPattern),
  createFormGroup() {
    return this.fb.group({
      id: undefined,
      orderNo: ["", [Validators.required, Validators.maxLength(30)]], // string;
      customerReference: ["", [Validators.required, Validators.maxLength(40)]], // string;
      dateOrdered: Date.now(), // string;
      orderTotal: 1, // boolean;
      orderNotes: ["", [Validators.maxLength(255)]], // string;
      orderStatus: OrderStatus.quote, // boolean;
      customerID: this.customerID,
    });
  }

  onDelete() {
    // console.log('this.editForm.value', this.editForm.value);
    this.editedOrder = Object.assign({}, this.editForm.value);

    this.apiService
      .UpdateOrder(this.editedOrder)
      .then(() => {
        this.OrderDeleted.emit(this.editedOrder);
      })
      .catch((error) => {
        console.error("Order Deletion Error: " + error.response);
      });
  }

  confirmDelete() {
    const dialogRef = this.dialog.open(ConfirmDeleteComponent, {
      data: {
        MessageTitle: "Delete Order!",
        MessageSub: "deleting - " + this.order.id,
        Message: "Are you sure?",
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.onDelete();
      }
    });
  }

  OnFormSubmit() {
    this.loading = true;
    if (this.editForm.valid) {
      // console.log("this.editForm.value", this.editForm.value);
      this.editedOrder = Object.assign({}, this.editForm.value);

      if (this.isAddingNewOrder) {
        this.CreateItem();
      } else {
        this.UpdateItem();
      }
    }
  }

  private UpdateItem() {
    this.orderService.AddUpdateOrder(this.editedOrder).then(
      () => {
        //  this.OrderUpdated.emit(this.editedOrder);
        this.loading = false;
        if(!this.orderItemAdded) {
          this.OrderUpdated.emit(this.editedOrder as Order);
        }
      },
      (error) => {
        console.error("Order Update Error: " + error.response);
      }
    );
  }

  private async CreateItem() {
    let res = await this.GetNextOrderNumber();
    this.editedOrder.orderNo = res.ordernumber;
    this.orderService.AddUpdateOrder(this.editedOrder).then(
      (data) => {
        this.OrderAdded.emit(data as Order);
        this.loading = false;
      },
      (error) => {
        console.error("Add New Order Error: " + error);
      }
    );
  }

  editClicked(orderItem: OrderItem, viewOnly: boolean = false) {  
    this.viewOnly = viewOnly;
    this.orderItem = orderItem;
    this.productSelected = orderItem.product;

    this.setTags(orderItem.product);

    if (this.IsTrack) {
      if (this.IsVerticalHeadrail) {
        this.addingCurve = true;
      } else {
        this.addingCurtainTrack = true;
      }
    } else {
      this.addingExtraItem = true;
    }
  }

  viewClicked(orderItem: OrderItem) {
    this.editClicked(orderItem, true);
  }

  deleteClicked(orderItem: OrderItem) {
    if (this.canDelete && orderItem.order.orderStatus === "quote") {

      this.orderItem = Object.assign({} as CreateOrderItemInput, orderItem);

      this.apiService
        .DeleteOrderItem({ id: this.orderItem.id })
        .then(() => {
          this.orderLines = this.orderLines.filter(
            (f) => f.id !== this.orderItem.id
          );
          this.UpdateOrder();
        })
        .catch((err) => {
         // console.log();
        });
    } else {
      const errorMessage = this.canDelete ? "Order Item cannot be deleted, you do not have permission" : "Order Item cannot be deleted because of the order status: " + orderItem.order.orderStatus;
      this.toastrService.error(errorMessage, "Error Deleting Order Item");
    }
  }

  cancelClicked(route: boolean = false) {
    if (!!route) {
      this.CancelClicked.emit();
    }

    this.confirmOrder = false
  }

  addCurve(orderItem: OrderItem) {

    this.addOrderItem(orderItem);
    this.addingCurve = false;
    this.addingCurtainTrack = false;
  }

  AddNewHeadrail() {
    this.orderItem = undefined;
    this.itemNumber = this.orderLines.length + 1;
    this.addingCurve = true;
  
  }

  AddNewCurtainTrack() {
    this.orderItem = undefined;
    this.itemNumber = this.orderLines.length + 1;
    this.addingCurtainTrack = true;
  }

  addExtra(orderItem: OrderItem) {

    this.addOrderItem(orderItem);
    this.addingExtraItem = false;
  }

  addOrderItem(orderItem: OrderItem) {
    this.orderItem = Object.assign({} as CreateOrderItemInput, orderItem);

    if (this.orderItem.id === undefined || this.orderItem.id === null) {
      this.orderItem.id = undefined;
      this.orderService
        .AddUpdateOrderItem(this.orderItem)
        .then((data) => {
          this.orderLines = [...this.orderLines, data as OrderItem];
          this.order.orderItems.items.push(data as OrderItem);
          this.orderItem = data as OrderItem;
          this.orderItemAdded = true;
          this.UpdateOrder();
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      this.orderService
        .AddUpdateOrderItem(this.orderItem)
        .then((data) => {
          this.orderItemUpdated = true;
          const index = this.orderLines.findIndex(
            (f) => f.id === this.orderItem.id
          );
          this.orderLines[index] = data as OrderItem;
          this.orderLines = [...this.orderLines];
          this.orderItem = data as OrderItem;
          this.UpdateOrder();
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  AddExtraItem() {
    this.orderItem = undefined;
    this.addingExtraItem = true;
  }

  UpdateOrder() {
    this.editedOrder = this.order;
    let price = 0;
    this.orderLines.forEach((s) => (price += s.price));

    // let itemsDiscount = 0;
    // this.orderLines.forEach((s) => (itemsDiscount += s.discount));

    // if (
    //   this.editedOrder.price === undefined ||
    //   this.editedOrder.price === null ||
    //   this.editedOrder.price !== price
    // ) {
      this.editedOrder.price = Math.round( price * 100) / 100;
      this.editedOrder.discount = Math.ceil(price * this.customerOrderDiscount) / 100;
      const subTotal =  price - this.editedOrder.discount;
      const vat = Math.round(subTotal * 20) / 100;
      this.order.tax = vat;
      this.editedOrder.orderTotal = subTotal + vat;
      let items = 0;
      this.editedOrder.delivery = 0;
      this.orderLines.forEach(w => items+=w.quantity);
      this.editedOrder.itemsTotal = items;
      this.UpdateItem();
    //}
    //  this.triggerZoneChanged();
  }


  triggerZoneChanged() {
    this.ngZone.run(() => {
     // console.log("Zone has been run");
    });
  }

  GetNextOrderNumber(): any | PromiseLike<any> {
    return this.apiCWS.GetNextOrderNumber().catch((err) => {
      console.log("err", err);
    });
  }

  placeOrder() {
    this.GetOrderItems();
    this.SubmitOrder.emit(this.order);
    this.confirmOrder = false;
  }

  ProductSelected(product: Product) {
    this.productSelected = product;
    this.addItem = false;

    this.setTags(product);

    if (this.IsTrack) {
      if (this.IsVerticalHeadrail) {
        this.AddNewHeadrail();
      } else {
        this.AddNewCurtainTrack();
      }
    } else {
      this.AddExtraItem();
    }
  }

  TrackSelected(trackType: string) {
    this.productSelected = undefined;
    this.addItem = false;

    if (trackType === "Vertical") {
      this.AddNewHeadrail();
    } else {
      this.AddNewCurtainTrack();
    }
  }

  setTags(product: Product) {
    this.tags = [];
    product.tags.items.forEach(t => {
      this.tags.push(t.tag.name);
    });
  }
}
